import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { AppleWalletPass, Loyalty } from '../models/loyalty.model';

@Injectable()
export class LoyaltyCardsService {
  private path = 'loyaltycards';
  constructor(private httpService: HttpService) {}

  public getLoyaltyCards(): Observable<Loyalty[]> {
    return this.httpService.makeGet<Loyalty[]>(this.path, null, null);
  }

  public addLoyaltyCard(CardID: number): Observable<any> {
    return this.httpService.makePost<any, any>('loyaltycard', null, null, { CardID: CardID.toString() });
  }

  public deleteLoyaltyCard(CardID: number): Observable<void> {
    return this.httpService.makeDelete<void>('loyaltycard/' + CardID);
  }

  public getGoogleWalletPass(): Observable<Loyalty[]> {
    return this.httpService.makeGet<Loyalty[]>('getgooglewalletpass', null, null);
  }

  public getAppleWalletPass(): Observable<AppleWalletPass> {
    return this.httpService.makeGet<AppleWalletPass>('getapplewalletpass', null, null);
  }

  public convertBlobToBase64 = (blob: Blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
}
